<script lang="ts">
	import { setLoadingState } from '$lib/actions/setLoadingState';
	import type { Snippet } from 'svelte';
	import type { HTMLButtonAttributes } from 'svelte/elements';
	type Props = {
		primary?: boolean;
		side?: 'right' | 'left';
		loading?: boolean;
		class?: string;
		children?: Snippet;
	} & HTMLButtonAttributes;
	let { primary = false, side = 'right', loading = false, class: classes, children, ...restProps }: Props = $props();
</script>

<button
	{...restProps}
	class:primary
	class:secondary={!primary}
	class:rounded-r-md={side === 'right'}
	class:rounded-l-md={side === 'left'}
	class="relative -ml-px inline-flex items-center space-x-2 border px-4 py-2 font-medium focus:border-violet-500 focus:outline-none focus:ring-1 focus:ring-violet-500 {classes}"
	use:setLoadingState={loading}
>
	{@render children?.()}
</button>

<style lang="postcss">
	.primary {
		@apply border-violet-600 bg-violet-600 text-white;
	}
	.primary:hover {
		@apply border-violet-700 bg-violet-700 text-violet-100;
	}

	.secondary {
		@apply border-violet-300 text-violet-800;
	}
	.secondary:hover {
		@apply border-violet-600 bg-violet-600 text-white;
	}
</style>
